import { EB_OPERATOR_LABEL, RRO_OPERATOR_LABEL } from 'constants/crewDetails';

import { NA_CLASSIFICATION_LABEL } from '../const';

/**
 * @typedef {Object} EmployeeInfo
 * @property {{ id: string, name: string } | null | undefined} [currentRun]
 * @property {{ id: string, name: string } | null | undefined} [run]
 * @property {Array<{ code: string }>} [jobs]
 * @property {string} [driverLicenseInfo]
 * @property {string} [medicalCheckInfo]
 * @property {HoursTracking | null} [hoursTracking]
 *
 * @typedef {Object} HoursTracking
 * @property {number} drivingMinutesBalance
 * @property {number} drivingMinutesLimit
 * @property {number} dutyMinutesBalance
 * @property {number} dutyMinutesLimit
 * @property {number} eightDaysDutyMinutesBalance
 * @property {number} eightDaysDutyMinutesLimit
 *
 * @typedef {{ employmentType: string }} EmploymentType
 */

/**
 * Derive the "classification" label from `currentRun`:
 * - `undefined` (backend has no record)    → `NA_CLASSIFICATION_LABEL`
 * - `null` (record exists, no run assigned) → `EB_OPERATOR_LABEL`
 * - object → `RRO_OPERATOR_LABEL`
 *
 * @param {EmployeeInfo['currentRun']} currentRun
 * @returns {string}
 */
export const deriveClassification = (currentRun) => {
	if (currentRun === undefined) return NA_CLASSIFICATION_LABEL;
	if (currentRun === null) return EB_OPERATOR_LABEL;
	return RRO_OPERATOR_LABEL;
};
